import React, { useState, useCallback } from 'react';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import data1 from '../../data/home1/projects/projects1';

function Projects() {
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleOpenLightbox = useCallback((index) => {
    setCurrentIndex(index);
    setOpen(true);
  }, []);

  const slides = data1.map(item => ({
    src: item.img,
    alt: item.title || 'Art Work',
    title: item.title
  }));

  return (
    <section className="tc-projects-style1" id='myart'>
      <div className="container">
        <div className="title mb-70">
          <h2 className="fsz-45">My Art Works</h2>
        </div>
        
        <div className="projects">
          <div className="tab-content" id="pills-tabContent">
            <div className="tab-pane fade show active" id="pills-proj1">
              <div className="projects-content float_box_container">
                <div className="projects-slider">
                  <div className="swiper-wrapper">
                    {data1.map((item, i) => (
                      <div key={i} className="swiper-slide">
                        <div className="project-card">
                          <div
                            className="img"
                            style={{ display: 'block', cursor: 'pointer' }}
                            onClick={() => handleOpenLightbox(i)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                handleOpenLightbox(i);
                              }
                            }}
                          >
                            <img 
                              src={item.img} 
                              alt={item.title || `Art Work ${i + 1}`}
                              className="img-cover"
                              style={{ 
                                width: '100%', 
                                height: '100%', 
                                objectFit: 'cover',
                                display: 'block'
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="float-cursor float_box">Hold <br /> and Drag</div>
              </div>
            </div>

            <div className="tab-pane fade" id="pills-proj2">
              <div className="projects-content float_box_container">
                <div className="projects-slider">
                  <div className="swiper-wrapper">
                    {data1.map((item, i) => (
                      <div key={`proj2-${i}`} className="swiper-slide">
                        <div className="project-card">
                          <div
                            className="img"
                            style={{ display: 'block', cursor: 'pointer' }}
                            onClick={() => handleOpenLightbox(i)}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                handleOpenLightbox(i);
                              }
                            }}
                          >
                            <img 
                              src={item.img} 
                              alt={item.title || `Art Work ${i + 1}`}
                              className="img-cover"
                              style={{ 
                                width: '100%', 
                                height: '100%', 
                                objectFit: 'cover',
                                display: 'block'
                              }}
                            />
                          </div>
                          <div className="info">
                            <div className="tags">
                              <a href="#">{item.sub1}</a>
                              <a href="#">{item.sub2}</a>
                            </div>
                            <h3 className="title"><a href="#">{item.title}</a></h3>
                            <div className="text">{item.desc}</div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="float-cursor float_box">Hold <br /> and Drag</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        index={currentIndex}
        slides={slides}
        controller={{ closeOnBackdropClick: true }}
        render={{
          buttonPrev: () => null,
          buttonNext: () => null,
        }}
        styles={{
          container: {
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
          },
          slide: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }
        }}
        carousel={{
          finite: true,
        }}
        animation={{ swipe: 150 }}
        on={{
          view: ({ index }) => setCurrentIndex(index),
        }}
      />
    </section>
  );
}

export default Projects;